@import 'src/global/train-colors';

.train-icon {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    margin: 0;
    height: 21px;
    overflow: hidden;

    &-name {
        display: inline-block;
        padding: 2px 0 2px 4px;
        background-color: var(--train-color);
        color: white;
        font-size: 14px;
        font-weight: bold;
        line-height: 17px;
        white-space: nowrap;
        z-index: 2;
    }

    &:after {
        content: "";
        width: 12px;
        background-color: var(--train-color);
        transform: skew(-28deg);
        transform-origin: top;
        z-index: 1;
    }
}

.train-icon-svg {
    @media #{$screen-max-md} {
        display: none;
    }
}

:host {
    display: inline-flex;
    gap: .2rem;
}

:host(:not(:first-of-type)) {

    .train-icon {
        &-name {
            padding-left: 0;
        }

        &:before {
            content: "";
            width: 12px;
            background-color: var(--train-color);
            transform: skew(-28deg);
            transform-origin: bottom;
            z-index: 1;
        }
    }
}

:host(:not(:last-of-type)) {
    margin-right: -5px;
}

:host(:not(.hide-icon):not(:first-of-type)) {
    margin-left: 0.625rem;
}
